// authApi.js
import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const StoreFinancialYear = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/utility/financial-years`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetFinancialYears = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/utility/financial-years`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "utilityentries fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetAllFinancialYears = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/utility/financial-years/get-all-financial-years?companyId=${data?.companyId}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "utilityentries fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetFinancialYearById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/utility/financial-years/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateFinancialYear = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/utility/financial-years/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteFinancialYear = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/utility/financial-years/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};